import { MediaTraderLineItemUpdate } from 'shared/src/api/line-item-types';
import {
  issuesOf,
  zodIssuesToFieldErrors
} from '@/features/line-items/line-item-form/common/selectors';

export type MediaTeamFormAction =
  | { type: 'SET_PLANNED_UNIT_COST'; value: number }
  | { type: 'SET_MEDIA_PLATFORMS'; value: number[] }
  | { type: 'TOUCH_FIELD'; field: string }
  | { type: 'BLUR_FIELD'; field: string };

type MediaTeamFormData = {
  planned_unit_cost: number | undefined;
  media_platform_ids: number[] | undefined;
};
export type MediaTraderState = {
  touched: ReadonlySet<string>;
  formData: MediaTeamFormData;
};

export function mediaTraderReducer(
  state: MediaTraderState,
  action: MediaTeamFormAction
): MediaTraderState {
  switch (action.type) {
    case 'SET_PLANNED_UNIT_COST':
      return updateFormState(state, 'planned_unit_cost', action.value);
    case 'SET_MEDIA_PLATFORMS':
      return updateFormState(state, 'media_platform_ids', action.value);
    case 'TOUCH_FIELD':
      return { ...state, touched: new Set([...state.touched, action.field]) };
    case 'BLUR_FIELD':
      return { ...state, touched: new Set([...state.touched, action.field]) };
  }
}

export function selectMediaTeamErrors(state: MediaTraderState): Record<string, string> {
  const result = MediaTraderLineItemUpdate.safeParse(state.formData);
  return result.success ? {} : zodIssuesToFieldErrors(issuesOf(result));
}

function updateFormState<K extends keyof MediaTeamFormData>(
  state: MediaTraderState,
  key: K,
  value: MediaTeamFormData[K]
): MediaTraderState {
  return {
    ...state,
    formData: { ...state.formData, [key]: value }
  };
}
